module.exports = __webpack_public_path__ + "static/media/hugo.373f5e06.jpg";